import { deleteConfirmModal } from "@helpers/DeleteValidate";
import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormData,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
    list: null,
    active: null,
    openForm: null,
    openApproveRejectMultipleForm: null,
    requestsWithoutScheduleCount: null,
};

export const GraduationOptionsRequests = createSlice({
    name: "GraduationOptionsRequests",
    initialState,
    reducers: {
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },

        setList: (state, action) => {
            state.list = action.payload;
        },
        clearList: (state) => {
            state.list = initialState.list;
        },

        setActive: (state, action) => {
            state.active = action.payload;
        },
        clearActive: (state) => {
            state.active = initialState.active;
        },

        setOpenForm: (state, action) => {
            state.openForm = action.payload;
        },

        setOpenApproveRejectMultipleForm: (state, action) => {
            state.openApproveRejectMultipleForm = action.payload;
        },

        setRequestsWithoutScheduleCount: (state, action) => {
            state.requestsWithoutScheduleCount = action.payload;
        },
        clearRequestsWithoutScheduleCount: (state) => {
            state.requestsWithoutScheduleCount =
                initialState.requestsWithoutScheduleCount;
        },
    },
});

export const {
    setPagination,
    clearPagination,
    setList,
    clearList,
    setActive,
    clearActive,
    setOpenForm,
    setOpenApproveRejectMultipleForm,
    setRequestsWithoutScheduleCount,
    clearRequestsWithoutScheduleCount,
} = GraduationOptionsRequests.actions;

export default GraduationOptionsRequests.reducer;

//* Actions
export const startShowGraduationOptionsRequests = ({
    page = 1,
    query = "",
    number_rows = 10,
    asList = 0,
    coordination_ids = [],
    curriculum_ids = [],
    level = [],
    degree = [],
    graduation_option = "All",
    diplomado_type_1 = [],
    diplomado_type_2 = [],
    diplomado_type_3 = [],
    status = [],
    payment_status = [],
    from = "",
    to = "",
    has_academic_schedule = null,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        if (asList) {
            params.set("asList", asList);
        } else {
            params.set("page", page);
            params.set("q", query);
            params.set("per_page", number_rows);
        }

        if (coordination_ids?.length > 0) {
            params.set(
                "coordination_ids",
                coordination_ids?.map((s) => s.value)?.join(",")
            );
        }
        if (curriculum_ids?.length > 0) {
            params.set(
                "curriculum_ids",
                curriculum_ids?.map((s) => s.value)?.join(",")
            );
        }
        if (level?.length > 0) {
            params.set("level", level?.map((l) => l.value)?.join(","));
        }
        if (degree?.length > 0) {
            params.set("degree", degree?.map((d) => d.value)?.join(","));
        }
        if (graduation_option) {
            params.set("graduation_option", graduation_option);
        }
        if (diplomado_type_1?.length > 0) {
            params.set(
                "diplomado_type_1",
                diplomado_type_1?.map((type) => type.value)?.join(",")
            );
        }
        if (diplomado_type_2?.length > 0) {
            params.set(
                "diplomado_type_2",
                diplomado_type_2?.map((type) => type.value)?.join(",")
            );
        }
        if (diplomado_type_3?.length > 0) {
            params.set(
                "diplomado_type_3",
                diplomado_type_3?.map((type) => type.value)?.join(",")
            );
        }
        if (status?.length > 0) {
            params.set("status", status?.map((s) => s.value)?.join(","));
        }
        if (payment_status?.length > 0) {
            params.set(
                "payment_status",
                payment_status?.map((ps) => ps.value)?.join(",")
            );
        }
        if (from) {
            params.set("from", from);
        }
        if (to) {
            params.set("to", to);
        }
        if (has_academic_schedule === 0 || has_academic_schedule === 1) {
            params.set("has_academic_schedule", has_academic_schedule);
        }

        const resp = await Call(
            `operators/graduation/requests/show`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            if (asList) {
                dispatch(setList(resp.success));
            } else {
                dispatch(setPagination(resp.success));
            }
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startExportGraduationOptionsRequests = ({
    coordination_ids = [],
    curriculum_ids = [],
    level = [],
    degree = [],
    // graduation_option = "All", // no pasar al exportar a Excel
    diplomado_type_1 = [],
    diplomado_type_2 = [],
    diplomado_type_3 = [],
    status = [],
    payment_status = [],
    from = "",
    to = "",
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("export", 1);
        if (coordination_ids?.length > 0) {
            params.set(
                "coordination_ids",
                coordination_ids?.map((s) => s.value)?.join(",")
            );
        }
        if (curriculum_ids?.length > 0) {
            params.set(
                "curriculum_ids",
                curriculum_ids?.map((s) => s.value)?.join(",")
            );
        }
        if (level?.length > 0) {
            params.set("level", level?.map((l) => l.value)?.join(","));
        }
        if (degree?.length > 0) {
            params.set("degree", degree?.map((d) => d.value)?.join(","));
        }
        // if (graduation_option) {
        //     params.set("graduation_option", graduation_option);
        // }
        if (diplomado_type_1?.length > 0) {
            params.set(
                "diplomado_type_1",
                diplomado_type_1?.map((type) => type.value)?.join(",")
            );
        }
        if (diplomado_type_2?.length > 0) {
            params.set(
                "diplomado_type_2",
                diplomado_type_2?.map((type) => type.value)?.join(",")
            );
        }
        if (diplomado_type_3?.length > 0) {
            params.set(
                "diplomado_type_3",
                diplomado_type_3?.map((type) => type.value)?.join(",")
            );
        }
        if (status?.length > 0) {
            params.set("status", status?.map((s) => s.value)?.join(","));
        }
        if (payment_status?.length > 0) {
            params.set(
                "payment_status",
                payment_status?.map((ps) => ps.value)?.join(",")
            );
        }
        if (from) {
            params.set("from", from);
        }
        if (to) {
            params.set("to", to);
        }

        const resp = await CallWithFormDataFile(
            `operators/graduation/requests/show`,
            "GET",
            params.toString()
        );

        downloadBlob(resp, "Reporte de solicitudes de opción de titulación");

        dispatch(stopUILoading());
    };
};

export const startGetByAcademicRecord = (academic_record_id) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/graduation/requests/get/by-academic-record/${academic_record_id}`,
            "GET"
        );

        if (resp.success) {
            dispatch(setList(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startSubmitGraduationOptionRequest = (
    graduation_option_request_id,
    values,
    setErrors,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const formData = new FormData();

        Object.entries(values).forEach(([key, value]) => {
            if (key !== "academic_record") {
                if (key === "tesis_progress_file" && value) {
                    formData.append(key, value[0]);
                } else if (typeof value === "boolean") {
                    formData.append(key, value ? "1" : "0");
                } else if (value === null) {
                    formData.append(key, "");
                } else {
                    formData.append(key, value);
                }
            }
        });

        const resp = await CallWithFormData(
            `operators/graduation/requests/submit/${graduation_option_request_id}`,
            "POST",
            formData
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                html: `
                    <div className="text-center">
                        <p>!Tu solicitud ha sido registrada!</p>
                        <span>Tu información será verificada y serás notificado acerca de cualquier cambio.</span>
                    </div>
                `,
                icon: "success",
                width: 610,
                allowOutsideClick: false,
                allowEnterKey: false,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDeleteGraduationOptionRequest = (
    graduation_option_request_id,
    callback = () => {}
) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `operators/graduation/requests/delete/${graduation_option_request_id}`,
                "DELETE"
            );

            if (resp.success) {
                Swal.fire({
                    title: "Éxito",
                    text: "Solicitud eliminada exitosamente.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 8000,
                });

                callback();
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        });
    };
};

export const startRejectGraduationOptionRequest = (
    graduation_option_request_id,
    values,
    setErrors,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/graduation/requests/reject/${graduation_option_request_id}`,
            "PUT",
            values
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Se rechazó la solicitud de opción de titulación.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });

            callback(resp.success);
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startApproveRejectMultipleGraduationOptionRequests = (
    values,
    setErrors,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/graduation/requests/approve-reject-multiple`,
            "POST",
            values
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Se rechazó la solicitud de opción de titulación.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });

            callback();
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startApproveGraduationOptionRequest = (
    graduation_option_request_id,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/graduation/requests/approve/${graduation_option_request_id}`,
            "PUT"
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Se aprobó la solicitud de opción de titulación.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });

            callback(resp.success);
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startGetRequestsWithoutScheduleCount = ({ graduation_option }) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("graduation_option", graduation_option);

        const resp = await Call(
            `operators/graduation/requests/get/without-schedule-count`,
            "GET",
            params.toString()
        );

        if ("success" in resp) {
            dispatch(setRequestsWithoutScheduleCount(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};
